import { get } from '../../utils/apiClient'

export const setTotalUnread = (count) => ({
  type: 'SET_TOTAL_UNREAD',
  payload: count,
})

export const incrementTotalUnread = () => ({
  type: 'INCREMENT_TOTAL_UNREAD',
})

export const decrementTotalUnread = () => ({
  type: 'DECREMENT_TOTAL_UNREAD',
})

export const fetchTotalUnread = () => async (dispatch) => {
  try {
    const data = await get('/messaging/unread-count')
    dispatch(setTotalUnread(data.count))
  } catch (error) {
    console.error('Erreur lors de la récupération du nombre de messages non lus:', error)
  }
}
